/* unplugin-vue-components disabled */import script from "./MoocCourse.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoocCourse.vue?vue&type=script&setup=true&lang=ts"

import "./MoocCourse.vue?vue&type=style&index=0&id=c6e715ac&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6e715ac"]])

export default __exports__